export const FOOTER = {
  'PRIVACY': 'Confidentialité',
  'TERMS': 'Mentions légales',
  'IDEAS': 'Idées & Feedback'
};
